export default "__VITE_ASSET__94884220__"